const RoleList = [
    {
        ID: 1,
        role: "Software Engineer",
        jd: [
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions'
        ]
    },
    {
        ID: 2,
        role: "Accountant",
        jd: [
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions'
        ]
    },
    {
        ID: 3,
        role: "Admin Officer",
        jd: [
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions'
        ]
    },
    {
        ID: 4,
        role: "Technical Support",
        jd: [
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions'
        ]
    },
    {
        ID: 5,
        role: "Online Support",
        jd: [
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions',
            'To develop upgrade and access software solutions'
        ]
    }
]

export default RoleList